<template>
  <v-expansion-panels v-model="isOpen" multiple flat>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-row align="center" justify="end" class="px-3 deep-purple--text lighten-3 font-weight-bold">
          {{ $t('common.filter') }}
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card color="deep-purple lighten-3" elevation="6" class="pa-2">
          <v-form>
            <v-row align="center" justify="space-between">
              <v-col class="d-flex flex-row align-items-center justify-content-start" cols="12">
                <v-col cols="12" md="3">
                  <CountryInput
                    v-model="value.country"
                    :placeholder="$t('students.country')"
                    :countries="countries"
                    @input="manageInput('country')"
                    hide-details
                    single-line
                    :filled="false"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    placeholder="Colegio"
                    flat solo light rounded dense
                    :items="schoolList"
                    v-model="value.schoolId"
                    @input="manageInput('school')"
                    color="white"
                    single-line
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    :placeholder="$t('users.user_type')"
                    flat solo light rounded dense
                    :items="userTypeOptions"
                    v-model="value.userType"
                    @input="manageInput('userType')"
                    color="white"
                    single-line
                    hide-details
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    placeholder="Nombre"
                    solo dense flat light rounded hide-details
                    v-model="value.firstname"
                    @input="manageInput('firstname')"
                  />
                </v-col>
              </v-col>
              <v-col class="d-flex flex-row align-items-center justify-content-start" cols="12">
                <v-col cols="12" md="3">
                  <v-text-field
                    placeholder="Apellidos"
                    solo dense flat light rounded hide-details
                    v-model="value.lastname"
                    @input="manageInput('lastname')"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    placeholder="Usuario / Email"
                    solo dense flat light rounded hide-details
                    v-model="value.username"
                    @input="manageInput('username')"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    placeholder="DNI"
                    solo dense flat light rounded hide-details
                    v-model="value.dni"
                    @input="manageInput('dni')"
                  />
                </v-col>
                <v-col cols="3" class="d-flex flex-column flex-md-row align-items-center justify-content-start">
                  <span>Estatus:</span>
                  <v-btn-toggle v-model="value.active" @change="manageInput('active')" dense class="mx-3" rounded>
                    <v-btn :value="1">Activo</v-btn>
                    <v-btn :value="0">Inactivo</v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-col>
            </v-row>
            <v-row class="px-2">
              <v-col cols="12" class="d-flex flex-column justify-content-end flex-md-row ml-auto px-2">
                <v-btn text color="white" class="text-decoration-underline" small rounded @click="reset">
                  Limpiar
                </v-btn>
                <v-btn class="search-btn" outlined rounded small @click="search">
                  Buscar 🔍
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import countryService from '../../../services/country.service';
import schoolService from '../../../services/school.service';
import { FLAGS_URL, COUNTRIES_CUSTOMER_ID } from '../../../constants/data';
import { defaultUsersFilter } from '../../../constants/filters';
import CountryInput from '../fields/CountryInput.vue';
import SnackbarMixin from '../../../mixins/snackbar';

export default {
  name: 'UsersFilter',
  components: { CountryInput },
  props: {
    value: { type: Object, default: () => ({ ...defaultUsersFilter }) },
  },
  data: () => ({
    isOpen: [],
    flagsPath: `${FLAGS_URL}countries_flags/`,
  }),
  async mounted() {
    const [countriesRes] = await Promise.all([countryService.findAll()]);
    if (countriesRes) this.setCountries([...countriesRes.data]);
  },
  computed: {
    ...mapState({
      countries: ({ common: { countries } }) => countries.filter((c) => COUNTRIES_CUSTOMER_ID.includes(c.id)),
      schoolList: ({ common: { schoolList } }) => schoolList,
    }),
    userTypeOptions() {
      return [
        { text: this.$t('users.type_all'), value: null },
        { text: this.$t('users.type_student'), value: 0 },
        { text: this.$t('users.type_teacher'), value: 2 },
        { text: this.$t('users.type_directive'), value: 3 },
        { text: this.$t('users.type_district_admin'), value: 7 },
        { text: this.$t('users.type_campus_group_admin'), value: 8 },
      ];
    },
  },
  watch: {
    'value.country': {
      async handler(nValue) {
        await this.getSchoolList(nValue);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('common', ['setCountries', 'setSchoolList']),
    manageInput(key) {
      this.$emit('input', { ...this.value, [key]: this.value[key] });
    },
    async getSchoolList(country) {
      try {
        if (country) {
          const { status, data } = await schoolService.getListByCountry(country);
          if (status === 200) this.setSchoolList([...data]);
          else this.setSchoolList([]);
        }
      } catch (e) {
        this.snackbarError(e.message);
      }
    },
    reset() {
      Object.keys(this.value).forEach((key) => {
        this.value[key] = defaultUsersFilter[key];
      });
    },
    search() {
      this.$emit('search');
    },
  },
  mixins: [SnackbarMixin],
};
</script>

<style scoped>
.search-btn {
  height: 40px;
  top: -6px;
  width: 180px;
  background: #4b398a;
  color: white;
}
</style>
